/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetPurchaseTransactionsQueryVariables = Types.Exact<{
  event_attendee_id?: Types.Maybe<Types.Scalars["Int"]>;
}>;

export type GetPurchaseTransactionsQuery = {
  gooseGameTransactions: Array<
    Pick<
      Types.GooseGameTransaction,
      | "id"
      | "type"
      | "points_change"
      | "item_quantity"
      | "item_id"
      | "created_at"
    >
  >;
};

export const GetPurchaseTransactionsDocument = gql`
  query getPurchaseTransactions($event_attendee_id: Int) {
    gooseGameTransactions(
      where: {
        AND: [
          { event_attendee_id: { equals: $event_attendee_id } }
          { type: { equals: PURCHASE } }
        ]
      }
    ) {
      id
      type
      points_change
      item_quantity
      item_id
      created_at
    }
  }
`;

/**
 * __useGetPurchaseTransactionsQuery__
 *
 * To run a query within a React component, call `useGetPurchaseTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseTransactionsQuery({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *   },
 * });
 */
export function useGetPurchaseTransactionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetPurchaseTransactionsQuery,
    GetPurchaseTransactionsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetPurchaseTransactionsQuery,
    GetPurchaseTransactionsQueryVariables
  >(GetPurchaseTransactionsDocument, baseOptions);
}
export function useGetPurchaseTransactionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPurchaseTransactionsQuery,
    GetPurchaseTransactionsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetPurchaseTransactionsQuery,
    GetPurchaseTransactionsQueryVariables
  >(GetPurchaseTransactionsDocument, baseOptions);
}
export type GetPurchaseTransactionsQueryHookResult = ReturnType<
  typeof useGetPurchaseTransactionsQuery
>;
export type GetPurchaseTransactionsLazyQueryHookResult = ReturnType<
  typeof useGetPurchaseTransactionsLazyQuery
>;
export type GetPurchaseTransactionsQueryResult = ApolloReactCommon.QueryResult<
  GetPurchaseTransactionsQuery,
  GetPurchaseTransactionsQueryVariables
>;
